import { render } from "./BlackButton.vue?vue&type=template&id=62e8feae"
import script from "./BlackButton.vue?vue&type=script&lang=js"
export * from "./BlackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__